import { Box, Stack } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DotLegalPaper from "@common/components/dotLegalPaper/DotLegalPaper";

export interface PolicySectionDragCloneProps {
    numberLabel: string;
    title: string | null;
}

function PolicySectionDragClone({ numberLabel, title }: PolicySectionDragCloneProps) {
    return (
        <Box sx={{ marginBottom: 2 }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ padding: 1, paddingLeft: 0 }}>
                <DragIndicatorIcon fontSize="small" sx={(theme) => ({ fill: theme.palette.grey[500], cursor: "grabbing" })} />
                <Box
                    sx={(theme) => ({
                        marginRight: 1,
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: `${theme.typography.pxToRem(20)}`,
                        fontWeight: theme.typography.fontWeightBold,
                        flexShrink: 0,
                    })}
                >
                    {numberLabel}.
                </Box>

                <Box
                    sx={(theme) => ({
                        flexGrow: 1,
                        fontWeight: theme.typography.fontWeightBold,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: `${theme.typography.pxToRem(20)}`,
                    })}
                >
                    {title}
                </Box>
            </Stack>
        </Box>
    );
}

export default PolicySectionDragClone;
